var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompanyLogoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7393 14.5348L16.9086 15.7222",
    stroke: "white",
    strokeWidth: 2.79646,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6719 9.66901L15.8413 10.8564",
    stroke: "white",
    strokeWidth: 2.79646,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0277 14.8042L29.7091 5.51743C29.5117 4.12698 28.2242 3.16002 26.8338 3.35797L6.60043 6.2386V6.2386C8.39618 5.98294 10.0597 7.22999 10.3179 9.02538L12.4446 23.8142",
    stroke: "white",
    strokeWidth: 2.79646,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5091 13.5745L5.31658 14.3693L4.52918 9.58016C4.24561 7.85543 5.50897 6.26132 7.25287 6.14339V6.14339",
    stroke: "white",
    strokeWidth: 2.79646,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2937 18.7551L32.1871 17.9766L31.4082 18.0806L25.4734 18.8731C24.5333 18.9986 23.8789 19.8708 24.0214 20.8085C24.1589 21.7131 24.9892 22.3456 25.8978 22.2376L26.9342 22.1145L24.2333 25.534L19.776 23.1288L19.2188 22.8281L18.805 23.3073L14.0719 28.788C13.4465 29.5122 13.5451 30.6103 14.2894 31.2115C14.9952 31.7815 16.0249 31.6939 16.6241 31.0127L19.8577 27.3373L24.3609 29.7708L24.9438 30.0857L25.3544 29.5659L29.6383 24.1421L29.8686 25.908C29.9904 26.8419 30.8534 27.495 31.7853 27.3585C32.7007 27.2244 33.3372 26.3778 33.2117 25.4612L32.2937 18.7551Z",
    stroke: "#11FF81",
    strokeWidth: 1.57675,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyLogoIcon);
export default __webpack_public_path__ + "static/media/companyLogoIcon.b6349fbab4ad91ef0e28b37abc49f1ce.svg";
export { ForwardRef as ReactComponent };